<template>
	<div class="table-search-box" :class="{'more':is_show_more}" :style="{height: box_height}">
		<section class="table-search-box__content" :class="{'more':is_show_more}" id="tableContent">
			<template  v-for="(item,index) in filterHeader">
				<div class="table-search-box__items" v-if="item.type == 'select'" >
					<label>{{item.label}}：</label>
					<el-select remote :remote-method="(query) => remoteMethod(query,item,index)" @focus="onFocus(item,index)" :loading="item.loading || false" v-model="defaultQuery[item.model]"
					 @change="onChange(item,index)"	collapse-tags :multiple="item.multiple" :placeholder="'请选择' + item.label" size="small" clearable
						filterable :disabled="item.disabled || false">
						<el-option v-for="(_item,index) in item.list" :key="index"
							:label="getLabelName(item,_item)"
							:value="item.valueName?_item[item.valueName]:_item.id"></el-option>
					</el-select>
				</div>
				<div class="table-search-box__items" v-if="item.type == 'input'" >
					<label>{{item.label}}：</label>
					<el-input v-model="defaultQuery[item.model]" :disabled = "item.disabled || false"
					:placeholder="'请输入' + item.label" size="small" clearable @keyup.enter.native="onSearch"></el-input>
				</div>
				<div class="table-search-box__items" v-if="item.type == 'datetimerange'">
					<label>{{item.label}}：</label>
					<el-date-picker
						v-model="defaultQuery[item.model]"
						:disabled = "item.disabled || false"
						:picker-options="setPickerOptions()"
						format="yyyy/MM/dd HH:mm:ss"
						value-format="timestamp"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						align="right"
						size="small"
						unlink-panels>
					</el-date-picker>
				</div>
				<template v-if="item.type == 'dynamic'">
					<slot></slot>
				</template>
			</template>
		</section>
		<section class="table-search-box__tools">
			<el-button @click.stop="resetFilter" icon="el-icon-refresh-right" size="small">重置</el-button>
			<el-button @click.stop="onSearch" icon="el-icon-search" size="small" type="primary">查询</el-button>
			<div class="more" @click="onMore" v-show="is_un_fold">更多查询<i :class="{'el-icon-caret-right': !is_show_more, 'el-icon-caret-bottom': is_show_more}"></i>
			</div>

		</section>
	</div>
</template>

<script>
	import { pickerOptionsMixin } from "utils/mixins";
	export default {
		mixins: [pickerOptionsMixin],
		props: {
			'filterHeader':{
				required:true
			},
			'defaultQuery':{
				required:true
			},
			'pageNumber':{
				default:'pageNumber'
			}
		},
		data() {
			return {
				is_un_fold: false,
				is_show_more:false,
				space:1,
				box_height:'70px'
			}
		},
		methods: {
			getLabelName(item,_item){
				if(!item.labelName) return _item.name;
				if(!item.childLabelName) return _item[item.labelName];
				return _item[item.labelName] + `【${_item[item.childLabelName]}】`
			},
			resetFilter() {
				for(let item of this.filterHeader) {
				    this.defaultQuery['pageSize'] = 10;
				    this.defaultQuery[this.pageNumber] = 1;
				    this.defaultQuery[item.model] = item.default;
				}
				this.$emit('resetBasicFilter')
			},
			async onSearch() {
				this.defaultQuery[this.pageNumber] = 1;
				await this.$emit('filterSearch', this.defaultQuery);
			},
			onFocus(row,index) {
				if(row.isRemote){
					this.$emit('filterSelectRemote',{
						row:row,
						index:index
					})
				}
			},
			onChange(row,index){
				if(row.child_model){
					let child_index = this.filterHeader.findIndex(el => el.model == row.child_model);
					if(child_index != 1){
						this.$emit('filterSelectRemote',{
							row:this.filterHeader[child_index],
							index:child_index,
							p_lists:row.list
						})
					}
				}
			},
			remoteMethod(query,row,index){
				if(row.isRemote){
					this.$emit('filterSelectRemote',{
						row:row,
						index:index,
						query:query
					})
				}
			},
			onMore(){
				this.is_show_more = !this.is_show_more;
				// let height = '70px';
				// let column = Math.floor(this.space);
				
				// if(column <= 0) {
				// 	height = this.filterHeader.length * 60 + 'px';
				// }else {
				// 	let yushu = Math.ceil(this.filterHeader.length / column);
				// 	height = yushu * 60 + 'px'
				// }
				// this.box_height = this.is_show_more ? height : '70px';
				this.box_height = this.is_show_more ? 'auto' : '70px';
			},
			setPickerOptions(type) {
			    let pickerOptions = Object.assign({}, this.pickerOptions);
			    if (type) delete pickerOptions.disabledDate;
			    return pickerOptions;
			},
			calcSize(){
				this.$nextTick(() => {
					let element = document.getElementById('tableContent');
					if(element){
						this.space = element.offsetWidth / 320;
						this.is_un_fold = this.filterHeader.length > this.space;
					}
					
				})
			}
		},
		mounted(){
			this.calcSize();
			window.addEventListener('resize',()=>{
				this.calcSize()
			})
		}
	}
</script>

<style lang="scss" scoped>
	.table-search-box {
		width: 100%;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		padding: 10px 20px;
		overflow: hidden;
		border-bottom: solid 5px #eff4f5;
		transition: all ease .2s;
		&.more {
			align-items: flex-start;
			height: auto;
		}

		&__tools {
			max-width: 260px;
			height: 50px;
			display: flex;
			align-items: center;

			.more {
				color: #337EFF;
				margin-left: 10px;
				cursor: pointer;
				font-size: 14px;
			}
		}

		&__content {
			width: calc(100% - 300px);
			display: flex;
			flex-wrap: wrap;
			// height: 100%;
			// overflow: hidden;
			&.more {
				justify-content: flex-start;
			}
		}

		&__items {
			font-size: 14px;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			width: 320px;
			height: 50px;
			box-sizing: border-box;
			::v-deep {
				.el-select,
				.el-input,
				.el-date-editor{
					width: 210px;
					flex-shrink: 0;
				}
			}

			label {
				display: inline-block;
				width: 90px;
				color: #3C4353;
				font-weight: 400;
				flex-shrink: 0;
			}

		}
		&__items-dynamic {
			width: 640px;
			height: 50px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			cursor: pointer;
			label {
				width: 90px;
				color: #3C4353;
				font-weight: 400;
				display: inline-block;
			}
		}
	}
</style>
